import { render, staticRenderFns } from "./FrontSearch.vue?vue&type=template&id=5c057210&scoped=true"
import script from "./FrontSearch.vue?vue&type=script&lang=js"
export * from "./FrontSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c057210",
  null
  
)

export default component.exports